module.exports = __webpack_public_path__ + "static/media/upcoming-match-avatar.d22eddcc.svg";